import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core';
import {CommonModule} from "@angular/common";
import {Router, RouterModule} from "@angular/router";
import { ConfigService } from 'src/app/services/config.service';
import { AuthService } from 'src/app/services/auth.service'
import {AssetsService} from '../../services/assets.service'
import { TranslationService } from '../../services/translation.service'
import {AssetPipe} from "../../pipes/asset.pipe";
import { GTM_EVENTS } from '../../constants/gtm-events.constants';


@Component({
  selector: 'fleet-landing-page',
  standalone: true,
  imports: [CommonModule, RouterModule, AssetPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LandingPageComponent implements OnInit {
  GTM_EVENTS = GTM_EVENTS;
  configService:ConfigService;
  isSession:boolean=false
  img1:any;
  img2:any;
  translationCode:any
  constructor(configService:ConfigService, private authService: AuthService, private assetsService: AssetsService,private translationService: TranslationService,
    private router: Router,
  ) {
    this.configService = configService
    this.isSession = this.authService.loggedInStatus

    let stateData = this.router.getCurrentNavigation()?.extras?.state;
    if (stateData?.['loginStatus']) {
      this.isSession = stateData?.['loginStatus'] as boolean;
    } else {
      this.isSession = history?.state?.['loginStatus'];
    }
  }
  ngOnInit() {
    this.setAssets()
    this.translationCode =
    this.translationService.getTranslationForPage('landing')
  }
  setAssets() {
    this.img1=
      this.assetsService.getAsset('landing')
    this.img2 =
      this.assetsService.getAsset('landing-report')


  }
  /* generateLink(relativePath:string){
    return this.configService.generateLink(relativePath)
  } */
}
